import { watch, nextTick } from '@vue/composition-api'

export default function useScrollToError(errors) {
  watch(errors, () => {
    nextTick(() => {
      const first = document.querySelector('.is-invalid')
      if (first) {
        first.scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
    })
  })
}



// WEBPACK FOOTER //
// ./src/composables/useScrollToError.js